import React, { FC } from 'react';
import { UseFormSetValue } from 'react-hook-form';
import styled from 'styled-components';

import Checkbox from '@/components/Checkbox';
import { Larger } from '@/components/Forms';
import Text from '@/components/Text';

const DisabledHint = styled(Text)`
  margin-top: 4px;
`;

interface Props {
  isProforma: boolean;
  setValue: UseFormSetValue<any>;
  resetFiles?: boolean;
  disabledReason?: string;
}

const ProformaCheckboxField: FC<Props> = ({
  isProforma,
  setValue,
  resetFiles,
  disabledReason,
}) => {
  const onChange = () => {
    // Only one of the two documents is sent, so drop whichever no longer applies.
    if (resetFiles) {
      setValue('file', null);
      setValue('proforma_file', null);
    }

    setValue('is_proforma', !isProforma);
  };

  return (
    <Larger>
      <Checkbox
        checked={!!isProforma}
        onChange={onChange}
        disabled={!!disabledReason}
      >
        <Text $type="smallHeadline">Proforma invoice</Text>
      </Checkbox>
      {!!disabledReason && (
        <DisabledHint as="div" $type="extraSmall" $color="gray">
          {disabledReason}
        </DisabledHint>
      )}
    </Larger>
  );
};

export default ProformaCheckboxField;
